module.exports = __webpack_public_path__ + "assets/img/comp_5-1.7b950b9a.png";